import { InView } from "react-intersection-observer";
import { styled } from "@material-ui/core/styles";
import { DEFAULT_BORDER_RADIUS } from "../../constants";

export const BackgroundVideo = styled(InView)({
  position: "relative",
  overflow: "hidden",
  width: "100%",
  height: "100%",
  borderRadius: DEFAULT_BORDER_RADIUS,
  "& > video": {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    objectFit: "cover"
  }
});
